var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"svgs-container",attrs:{"id":"container"}},[_c('section',{attrs:{"id":"franceContainer"}}),_c('section',{attrs:{"id":"islandsContainer"}}),_c('section',{attrs:{"id":"parisContainer"}}),(!_vm.hideBelgium)?_c('section',{attrs:{"id":"belgiumContainer"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }